import type { SoundType } from '@/lib/soundConfig';

export type EarconEvent =
  | 'cartAdd'
  | 'cartRemove'
  | 'favoriteAdd'
  | 'favoriteRemove'
  | 'orderCreated'
  | 'success'
  | 'error'
  | 'sidebarOpen'
  | 'sidebarClose';

export const EARCON_EVENT_TO_SOUND: Record<EarconEvent, SoundType> = {
  cartAdd: 'add',
  cartRemove: 'decrease',
  favoriteAdd: 'favorite',
  favoriteRemove: 'removeFavorite',
  orderCreated: 'orderCreated',
  success: 'success',
  error: 'error',
  sidebarOpen: 'sidebarOpen',
  sidebarClose: 'sidebarClose',
};

export const EARCON_COOLDOWN_MS: Partial<Record<EarconEvent, number>> = {
  sidebarOpen: 90,
  sidebarClose: 90,
};
